"use client"

import { useState } from "react"
import { PageLayout } from "@/components/page-layout"
import { TickerSearch } from "@/components/ticker-search"
import { TickerResults } from "@/components/ticker-results"

interface TickerData {
  ticker: string
  annualizedStandardDeviation: number
  halfLife: number
  sic: string
  models: {
    model: string
    blockage: number
    dlom: number
  }[]
}

export default function TickerLookupPage() {
  const [tickerData, setTickerData] = useState<TickerData | null>(null)
  const [isLoading, setIsLoading] = useState(false)

  return (
    <PageLayout>
      <div className="max-w-6xl mx-auto space-y-6">
        <div>
          <h1 className="text-2xl font-bold text-foreground mb-2">TICKERS</h1>
          <p className="text-muted-foreground">
            Search for ticker data and retrieve discount calculations
          </p>
        </div>

        <TickerSearch onSearch={setTickerData} onLoadingChange={setIsLoading} />

        <TickerResults data={tickerData} isLoading={isLoading} />
      </div>
    </PageLayout>
  )
}
